<style lang="scss">
</style>

<template>
	<div>
		<vBread class="tablelist-header">
			<vBreadItem>编辑装箱</vBreadItem>
		</vBread>
		<div class="bg-fff shadow margin-bottom-10">
			<header class="detail-title font-bold">调拨产品明细</header>
			<div class="margin-left-20">调拨计划单号:
				<router-link :to="getDetailLink">{{transferOutboundPlanNo}}</router-link>
			</div>
			<TableList v-bind="handleProductTableProps" class="padding-20"></TableList>
		</div>
		<div class="bg-fff shadow padding-bottom-20">
			<header class="detail-title font-bold">装箱明细</header>
			<aside class="button-group margin-left-20">
				<vButton theme="primary" @click.native="submitAllBoxing">一键装箱</vButton>
				<vButton theme="info" @click.native="uploadBoxing">导入装箱</vButton>
				<vButton theme="error" @click.native="submitFinishBoxing">装箱完成</vButton>
				<vButton theme="warning" @click.native="getAllBoxingLabel" v-show="labelCreateStatus!=10">{{labelCreateStatus==20?'重新生成箱标':'生成箱标'}}</vButton>
				<vButton theme="default" ghost @click.native="downloadBoxingUrl" v-show="labelCreateStatus==20">下载箱标</vButton>
			</aside>
			<vForm :label-width="120" ref="form" class="margin-15 clearfix" :rules="required">
				<vCol span="12">
					<vFormItem label="ERP SKU:" prop="erpSku">
						<vSelect
							v-model="formData.erpSku"
							filterable
							clearable
							search
							@on-search="getErpSkuList"
							@on-scroll-loading="getLoadingErpSku"
							@on-change="getRelationData"
						>
							<vOption v-for="item in erpSkuList" :value="item.erpSku" :key="item.erpSku">{{ item.erpSku }}</vOption>
							<!-- <div v-if="erpSkuList.length==0" style="padding:5px 10px;">暂无数据</div> -->
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="装箱入数" prop="packedQty">
						<vInputNumber v-model="formData.packedQty"/>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="箱条码">
						<vInput v-model="formData.boxBarcode" placeholder="不填则系统自动生成"/>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="托盘条码">
						<vInput v-model="formData.trayBarcode"/>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="外箱毛重(kg)" prop="packedWeight">
						<vInputNumber v-model="formData.packedWeight"/>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="外箱长(cm)" prop="packedLength">
						<vInputNumber v-model="formData.packedLength"/>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="外箱宽(cm)" prop="packedWidth">
						<vInputNumber v-model="formData.packedWidth"/>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="外箱高(cm)" prop="packedHeight">
						<vInputNumber v-model="formData.packedHeight"/>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem>
						<vButton class="margin-right-20" theme="primary" icon="add" @click="submit">逐个添加</vButton>
					</vFormItem>
				</vCol>
			</vForm>
			<div class="margin-left-30">
				<vButton class="margin-right-20" theme="warning" icon="remove" @click="deleteSubmit">删除所选</vButton>
				<vButton class="margin-right-20" theme="error" icon="nuclear" @click="clearSubmit">清空数据</vButton>
				<vButton class="margin-right-20" theme="success" icon="nuclear" @click="downloadBoxing">导出装箱</vButton>
			</div>
			<TableList v-bind="handleBoxTableProps" style="margin:20px" @on-check-change="getCheckedData"></TableList>
			<vLoading fix :loading="loading" transfer></vLoading>
		</div>
	</div>
</template>

<script>
import {
	mapState,
	mapGetters
} from 'vuex'
import {
	HttpSaveAllotBoxing,
	HttpAllotBoxing,
	HttpAllotProductList,
	HttpErpSkuList,
	HttpSaveAllotBoxings,
	HttpFinishAllotBoxing,
	HttpDelAllotBoxing,
	HttpClearAllotBoxing,
	HttpAllotBoxingLabel,
} from '@/service/allotment/allots'
import TableList from '@components/templates/tablelist'
import compUpload from '@components/templates/upload'
import compModal from '@components/templates/modal'

export default {
	components: {
		TableList
	},
	data() {
		return {
			query: false,
			loading: false,
			transferType: this.$route.query.transferType,
			transferOutboundPlanNo: this.$route.query.transferOutboundPlanNo,
			labelCreateStatus:this.$route.query.labelCreateStatus,
			id: this.$route.query.id,
			startUp: 1,
			erpSkuList: [],
			formData: {},
			required: {
				['*']: {
					required: true,
					message: "该信息不能为空,请填写"
				}
			}
		}
	},
	created() {
		this.getErpSkuList();
	},

	computed: {
		...mapState('boss', ['products']),
		...mapGetters('boss', ['warehouses']),
		getDetailLink() {
			return {
				name: "allotUpdate",
				params: { type: "query" },
				query: { id: this.id, transferType: this.transferType },
			}
		},
		handleProductTableProps() {
			return {
				columns: [{
					title: "序号",
					type: 'index',
					width: 60
				}, {
					title: "产品",
					key: 'sku'
				}, {
					title: "计划数",
					key: 'qty',
				}, {
					title: "已装箱数量",
					key: 'qtyPacked',
				}],
				initFormData: {
					transferOutboundPlanNo: this.transferOutboundPlanNo
				},
				ajaxRequest: HttpAllotProductList,
				startUp: true
			}
		},
		handleBoxTableProps() {
			const transferOutboundPlanNo = this.transferOutboundPlanNo;
			return {
				initFormData: {
					transferOutboundPlanNo
				},
				ajaxRequest: HttpAllotBoxing,
				startUp: this.startUp,
				columns: [{
					type: 'selection',
					width: 60,
					align: "center",
					formName: 'id'
				}, {
					title: "序号",
					key: 'sid'
				}, {
					title: "ERP SKU",
					key: 'sku'
				}, {
					title: "装箱数",
					key: 'packedQty',
				}, {
					title: "箱条码",
					key: 'boxBarcode',
				}, {
					title: "托盘条码",
					key: 'trayBarcode',
				}, {
					title: "外箱毛重（kg）",
					key: 'cartonGrossWeight',
				}, {
					title: "外箱尺寸(长*宽*高)",
					key: 'cartonLength',
					render(h, {
						row
					}) {
						return <div>
							{row.cartonLength}*
                        {row.cartonWidth}*
                        {row.cartonHeight}(cm*cm*cm)
                        </div>
					}
				}]
			}
		},
	},
	methods: {
		getRelationData(val) {
			const erpSku = this.formData.erpSku;
			this.erpSkuList.some((item) => {
				if (item.erpSku === erpSku) {
					this.formData = { ...this.formData, ...item }
					return true;
				}
			})
		},
		getLoadingErpSku(val) {
			this.erpskuPage += 1;
			this.getErpSkuList(val, 'loading');
		},
		downloadBoxingUrl() {
			this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/downloadBoxLabel", {
				transferOutboundPlanId: this.id
			},'download');
		},
		downloadBoxing() {
			this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/exportItemBox", {
				transferId: this.id
			},'download');
		},
		uploadBoxing() {
			const attrs = {
				data: {
					contextId: global.SYSID,
					transferId: this.id
				},
				action: process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/importItemBox",
				name: "excelFile",
				download() {
					this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/transferBoxTemplate",{},'download');
				},
			}
			this.$VModal.default({
				title: "导入装箱",
				width: 500,
				showFooter: false,
				render: (h) => {
					return this.$createElement(compUpload, {
						attrs,
						on: {
							'on-success': () => {
								this.startUp += 1;
								this.$VModal.destroy();
							},
							'on-cancel': () => {
								this.$VModal.destroy();
							}
						}
					})
				}
			})
		},
		getCheckedData(rows, ids = []) {
			console.log(rows, ids)
			this.__ids = ids.join(',')
		},
		async getErpSkuList(val, type) {
			if (type !== 'loading') this.erpskuPag = 1;
			const formData = {
				rows: 10,
				page: this.erpskuPag,
				sidx: 'id',
				sord: 'desc',
				search: {
					EQ_transferOutboundPlanId: this.id,
					CN_sku: this.formData.erpSku,
				}
			}
			HttpErpSkuList(formData).then(res => {
				const data = (res.data || {}).content || [];
				if (type === 'loading') {
					this.erpSkuList = [...this.erpSkuList, ...data];
					return;
				}
				this.erpSkuList = data
			});
		},

		submitFinishBoxing() {
			this.$VModal.info({
				title: "确认信息",
				content: "装箱完成后，不可再修改装箱信息，请谨慎操作！确认后自动生成箱标，请稍后进入单据列表->操作->导出箱标进行箱标签下载",
				async: true,
			}, {
				'on-after-close': () => {
					this.$VModal.destroy();
				},
				'on-confirm': (name) => {
					HttpFinishAllotBoxing({
						transferId: this.id
					}).then(res => {
						this.$VModal.destroy();
					}, err => {
						console.log(this.$VModal.get(name))
						this.$VModal.get(name).loading=false;
						this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
					})
				}
			})
		},
		handleGoback() {
			const data = {
				0: 'serviceAllot',
				1: 'otherAllot',
				2: 'procure',
				3: 'amazonAllot',
			}
			this.$router.push({ name: data[this.transferType] });
		},
		getAllBoxingLabel() {
			this.$VModal.info({
				title: "确认信息",
				content: "生成箱标按钮点击后，页面提示框弹出提示：箱标生成中，请耐心等候，或稍后进入单据列表->操作->导出箱标进行箱标签下载。",
				async: true,
			}, {
				'on-after-close': () => {
					this.$VModal.destroy();
				},
				'on-confirm': (name) => {
					HttpAllotBoxingLabel({
						transferOutboundPlanNo: this.transferOutboundPlanNo
					}).then(res => {
						this.handleGoback();
						this.$VModal.destroy();
					}, err => {
						this.$VModal.get(name).loading=false;
						this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
					})
				}
			})
		},
		async submitAllBoxing() {
			this.loading = true;
			HttpSaveAllotBoxings({
				transferId: this.id
			}).then(res => {
				this.startUp += 1;
			}, err => {
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			}).finally(result => {
				this.loading = false;
			})
		},
		async clearSubmit() {
			this.loading = true;
			HttpClearAllotBoxing({
				transferOutboundPlanNo: this.transferOutboundPlanNo,
			}).then(res => {
				this.startUp += 1;
			}, err => {
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			}).finally(result => {
				this.loading = false;
			})
		},
		async deleteSubmit() {
			console.log(this.__ids)
			if (!this.__ids) return
			this.loading = true;
			HttpDelAllotBoxing({
				idsStr: this.__ids,
			}).then(res => {
				this.startUp += 1;
			}, err => {
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			}).finally(result => {
				this.loading = false;
			})
		},
		async submit() {
			let data = await this.$refs['form'].validate();
			if (!data) return;
			this.loading = true;
			HttpSaveAllotBoxing({
				...this.formData,
				transferId: this.id,
			}).then(res => {
				this.startUp += 1;
				this.formData = {};
			}, err => {
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			}).finally(result => {
				this.loading = false;
			})
		}
	},

}
</script>
